var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[(_vm.isLoading)?_c('div',[_c('OtherLoading',{attrs:{"variant":"dark"}})],1):_c('div',{staticClass:"content-reward"},[_c('div'),_c('HistoryCoupon',{attrs:{"detail":_vm.privilegeDetail}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }